<template>
    <div>
        <mu-dashboard-super v-if="isSuper()"></mu-dashboard-super>
        <mu-dashboard-admin-ziad v-if="isAdminZiad()"></mu-dashboard-admin-ziad>
        <mu-dashboard-admin v-if="isAdminResale()"></mu-dashboard-admin>
        <mu-dashboard-commercial v-if="isCommercial()"></mu-dashboard-commercial>
        <mu-dashboard-user v-if="isUser() || isAdminClient()"></mu-dashboard-user>
    </div>
</template>

<script>
    import DashboardSuper from '@/views/App/Dashboard/Super'
    import DashboardAdminZiad from '@/views/App/Dashboard/AdminZiad'
    import DashboardAdmin from '@/views/App/Dashboard/Admin'
    import DashboardCommercial from '@/views/App/Dashboard/Commercial'
    import DashboardUser from '@/views/App/Dashboard/User'

    export default {
        name: 'app-dashboard',

        // ╔═╗╔═╗╔╦╗╔═╗╔═╗╔╗╔╔═╗╔╗╔╔╦╗╔═╗╔═╗
        // ║  ║ ║║║║╠═╝║ ║║║║║╣ ║║║ ║ ║╣ ╚═╗
        // ╚═╝╚═╝╩ ╩╩  ╚═╝╝╚╝╚═╝╝╚╝ ╩ ╚═╝╚═╝

        components: {
            'mu-dashboard-super': DashboardSuper,
            'mu-dashboard-admin-ziad': DashboardAdminZiad,
            'mu-dashboard-admin': DashboardAdmin,
            'mu-dashboard-commercial': DashboardCommercial,
            'mu-dashboard-user': DashboardUser
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            /**
             * Pegando os dados do usuário gravados no state
             */
            user () {
                return this.$store.state.user
            },

            /**
             * Pegando os dados da empresa gravados no state
             */
            company () {
                return this.$store.state.company
            }
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        /**
         * Os métodos fazendo verificando o tipo de permissão do usuário para ver que tipo de
         * dashbaord iremos mostrar ao usuário
         */
        methods: {
            isSuper () {
                return this.user.permition === 'S'
            },
            isAdminZiad () {
                return this.user.permition === 'A' && this.company.isProvider
            },
            isAdminResale () {
                return this.user.permition === 'A' && !this.company.isProvider && this.company.customType === 'R'
            },
            isAdminClient () {
                return this.user.permition === 'A' && !this.company.isProvider && this.company.customType === 'C'
            },
            isCommercial () {
                return this.user.permition === 'C'
            },
            isUser () {
                return this.user.permition === 'U'
            }
        }
    }
</script>
